import * as React from 'react';
// Tell cell that browser support sticky
const StickyContext = React.createContext(false);
export default StickyContext;
